import React, { useState } from "react";
import {
  AccordianNew,
  Backdrop,
  Button,
  DropdownMenu,
  FormFieldSet,
  LogoLoader,
  Modal,
  showToast,
  SmartTooltip,
  TableAdv,
  VerticalTabs,
} from "../../../../../components";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  getRaSettingsStart,
  saveRaSettingsStart,
  updateRaSettingsStart,
} from "../../../../../redux/slices/leads/leadsSlice";

import { ALLOWED_ORIGINS, ATS_API_URL } from "../../../../../redux/apiConfig";
import {
  checkAdminAdded,
  deleteBDMLocation,
  deleteLocalRestriction,
  deleteRALocation,
  getIntegrationAccess,
  updateIntegrationAccessCxId,
  updateIntegrationAccessStatus,
} from "../../../../../redux/slices/setting/settingApi";
import {
  getBDMLocationsStart,
  getLocalRestrictionStart,
  getRALocationsStart,
  getRecruitmentSettingsStart,
  setActiveGmailStart,
} from "../../../../../redux/slices/setting/settingsSlice";
import { useModuleAccess, usePagination } from "../../../../../hooks";
import { dateFormator, mapTableRows } from "../../../../../utils";
import GeneralSettingsAddButtonModal from "./Modals/GeneralSettingsAddButtonModal";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";
import GeneralSettingsAddRALocationButtonModal from "./Modals/GeneralSettingsAddRALocationButtonModal";
import GeneralSettingsBDMAddButtonModal from "./Modals/GeneralSettingsBDMAddButtonModal";
import { getItem } from "../../../../../utils/localStorageUtils";
import AiRecruiterCall from "./GeneralSettings/AiRecruiterCall";

const allowedOrigins = ALLOWED_ORIGINS;
const GeneralSettings = () => {
  const portal = getItem("portal");
  const [activeIndex, setActiveIndex] = useState(0);
  // const [addCompany, setAddCompany] = useState(1);
  const [addCompany, setAddCompany] = useState("2");
  const [showEnableButton, setShowEnableButton] = useState(false);
  const [showEnabledButton, setShowEnabledButton] = useState(false);
  const [showAddButtonModal, setShowAddButtonModal] = useState(false);
  const [showLocationAddButtonModal, setshowLocationAddButtonModal] = useState(false);
  const [showBDMLocationAddButtonModal, setshowBDMLocationAddButtonModal] = useState(false);
  const [showStepTwo, setShowStepTwo] = useState(false);
  const [showCxModal, setShowCxModal] = useState(false);
  const [isGoogleConnected, setIsGoogleConnected] = useState(false);
  const [isDisconnected, setIsDisconnected] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openAccordion, setOpenAccordion] = useState(0);
  const [lockInPeriod, setLockInPeriod] = useState("");
  const [lockinProspectPeriod, setLockinProspectPeriod] = useState("");
  const [tosLink, setTosLink] = useState(null);
  const [cxKey, setCxKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [existingUiid, setExistingUiid] = useState(null);
  const { value } = useSelector((state) => state.totalCount);
  const [integrationAccessUiid, setIntegrationAccessUiid] = useState(null);
  const [bdmJobCloseNumber, setBdmJobCloseNumber] = useState();
  const [selectedJobBoard, setSelectedJobBoard] = useState(1);
  const [selectedAutoAssign, setSelectedAutoAssign] = useState();
  const [enteredCredits, setEnteredCredits] = useState("");

  const dispatch = useDispatch();
  const [isRegenerating, setIsRegenerating] = useState(false);
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => { }
  );
  const totalCount = value?.localRestrictionCount?.data || 0;
  console.log(value)
  // const locationCount = 
  const activeGmail = useSelector(
    (state) =>
      state.settings.generalSettings.raSettings.companySettings.activeGmail
  );
  const restrictions = useSelector(
    (state) => state.settings.generalSettings.raSettings.localRestrictions
  );
  const { raAddedLocations } = useSelector(
    (state) => state.settings
  );
  const { bdmAddedLocations } = useSelector(
    (state) => state.settings
  );
  const { recruitmentSettings, uiid } = useSelector(
    (state) => state.settings?.generalSettings
  );
  // const raSettings = useSelector((state) => state.leads.raSettings);
  const raSettings = useSelector((state) => state.leads.raSettings?.data);
  const settingLoading = useSelector((state) => state?.leads?.loading);
  const { user } = useSelector((state) => state.auth);
  const options = [
    "RA Setting",
    "BDM Setting",
    "Recruitement",
    "Bench Sale Setting",
  ];

  const handleSelectionChange = (e) => {
    setAddCompany(e.target.value);
  };
  useEffect(() => {
    const handleMessage = (event) => {
      // if (event.origin !== "http://localhost:9191") return;
      // if (!allowedOrigins.includes(event.origin)) return;
      if (!Array.isArray(allowedOrigins) || !allowedOrigins.includes(event.origin)) return;
      // console.log("Message event:", event.origin, event.data);

      const data = event.data;
      // console.log("Google Auth Message:", data);

      if (data?.error && data?.link) {
        setTosLink(data.link);
        setShowEnableButton(true);
        showToast(data.error, "error");
        return;
      }

      if (data?.error) {
        // showToast(data.error, "error");
        // setShowEnableButton(true);
        showToast(data?.error, "error", 2000);
        return;
      }

      if (data?.user) {
        setIsGoogleConnected(true);
        dispatch(setActiveGmailStart({ gmail: data.user.email }));
        setShowEnableButton(false);
        setTosLink(null);
        // setShowStepTwo(true);
        if (!isRegenerating) {
          setShowStepTwo(true); // <-- only show Step2 for first login
        }

        setIsRegenerating(false);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);
  const handleGoogleClick = async () => {
    try {
      // setShowEnableButton(true);

      // check if admin added clientId and secret
      setLoading(true);
      const checkRes = await checkAdminAdded({
        coll: "Integration",
        fil: {
          category: { type: "NONE", value: 7 },
          type: { type: "NONE", value: 1 },
        },
      });
      if (!checkRes?.data || checkRes.data.length === 0) {
        showToast("Reach to admin for client Id and Secret key", "error");
        setLoading(false);
        return;
      }
      const integrationId = checkRes.data?.data?.uiid;
      setIntegrationAccessUiid(integrationId);
      let accessRes = await getIntegrationAccess({
        ret: "status uiid accessConfig",
        coll: "IntegrationAccess",
        fil: {
          integrationId: { type: "NONE", value: integrationId },
          addedBy: { type: "NONE", value: user.data.uiid },
        },
      });
      
      if (accessRes?.data) {
        const { status, uiid, accessConfig } = accessRes.data.data;
        if (status === 2) {
          const statusUpdate = await updateIntegrationAccessStatus({
            uiid,
            payload: [
              {
                type: "SET",
                value: { status: 1 },
              },
            ],
          });
        }
        const projects = accessConfig?.projects || [];
        const cxId = projects[0]?.cxId;

        if ((!cxId || cxId === "") && !isRegenerating) {
          setShowStepTwo(true);
        } else {
          dispatch(
            setActiveGmailStart({
              gmail: accessRes.data.data.accessConfig.activeGmail,
            })
          );
          setIsGoogleConnected(true);
          setShowEnableButton(false);
          setTosLink(null);
        }
      } else {
        const width = 500;
        const height = 600;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2.5;

        const stateObj = {
          integrationId: integrationId,
          userId: user.data.uiid,
          addedBy: user.data.uiid,
        };

        const stateParam = encodeURIComponent(JSON.stringify(stateObj));
        const authUrl = `${ATS_API_URL}/integration/google-auth?state=${stateParam}`;

        window.open(
          authUrl,
          "GoogleLogin",
          `width=${width},height=${height},left=${left},top=${top}`
        );
      }
    } catch (error) {
      console.error("Error in handleGoogleClick:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveCxKey = async () => {
    if (!cxKey) {
      showToast("CX key cannot be empty", "error", 2000);
      return;
    }
    if (!integrationAccessUiid) {
      showToast("No uiid found to add cxkey", "error");
      return;
    }
    try {
      setLoading(true);
      let accessRes = await getIntegrationAccess({
        ret: "status uiid accessConfig",
        coll: "IntegrationAccess",
        fil: {
          integrationId: { type: "NONE", value: integrationAccessUiid },
          addedBy: { type: "NONE", value: user.data.uiid },
        },
      });
      if (!accessRes?.data) {
        showToast("No integration Id", "error");
        return;
      }
      const { uiid } = accessRes.data.data;

      const res = await updateIntegrationAccessCxId({
        uiid: uiid,
        payload: [
          {
            type: "SET",
            value: { "accessConfig.projects.$[].cxId": cxKey },
          },
        ],
      });

      if (res?.data) {
        setIsGoogleConnected(true);
        setShowCxModal(false);
        setShowStepTwo(false);
        setIsDisconnected(false);
        setOpenAccordion(0);
        dispatch(
          setActiveGmailStart({
            gmail: accessRes.data.data.accessConfig.activeGmail,
          })
        );
        setIsGoogleConnected(true);
        setShowEnableButton(false);
        setTosLink(null);
        showToast("CX Key saved successfully!", "success");
      } else {
        showToast("Failed to save CX Key", "error");
      }
    } catch (err) {
      console.error("Failed to save CX key:", err);
      showToast("Failed to save CX Key", "error");
    } finally {
      setCxKey("");
      setLoading(false);
    }
  };

  const handleEnableApi = () => {
    setShowEnableButton(false);
    setShowEnabledButton(true);
  };

  const handleEnabledButtonClick = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      setShowStepTwo(true);
    }, 2000);
  };
  const handleDisconnect = async () => {
    if (!integrationAccessUiid) {
      showToast("Access Id not found", "error", 2000);
      return;
    }
    try {
      let accessRes = await getIntegrationAccess({
        ret: "status uiid",
        coll: "IntegrationAccess",
        fil: {
          integrationId: { type: "NONE", value: integrationAccessUiid },
          addedBy: { type: "NONE", value: user.data.uiid },
        },
      });
      if (!accessRes?.data) {
        showToast("No IntegrationId found", "error");
        return;
      }
      const { uiid } = accessRes.data.data;
      const res = await updateIntegrationAccessStatus({
        uiid,
        payload: [
          {
            type: "SET",
            value: { status: 2 },
          },
        ],
      });
      if (res?.data) {
        setIsGoogleConnected(false);
        dispatch(setActiveGmailStart({ gmail: null }));
        setIsDisconnected(true);
        showToast("Disconnected successfully", "success", 2000);
      } else {
        showToast("Failed to disconnect", "error", 2000);
        return;
      }
    } catch (error) {
      console.log("An error occured", error);
    }
  };

  // const handleRegenerate = () => {
  //   setIsGoogleConnected(false);
  //   setIsDisconnected(false);
  //   setShowEnableButton(false);
  //   setShowEnabledButton(false);
  //   setShowStepTwo(false);
  //   setShowCxModal(false);
  // };
  const handleRegenerate = async () => {
    try {
      setLoading(true);
      setIsRegenerating(true);
      const checkRes = await checkAdminAdded({
        coll: "Integration",
        fil: {
          category: { type: "NONE", value: 7 },
          type: { type: "NONE", value: 1 },
        },
      });

      if (!checkRes?.data || checkRes.data.length === 0) {
        showToast("Reach to admin for client Id and Secret key", "error");
        setLoading(false);
        return;
      }

      const integrationId = checkRes.data?.data?.uiid;

      const width = 500;
      const height = 600;
      const left = window.screenX + (window.outerWidth - width) / 2;
      const top = window.screenY + (window.outerHeight - height) / 2.5;

      const stateObj = {
        integrationId: integrationId,
        userId: user.data.uiid,
        addedBy: user.data.uiid,
      };

      const stateParam = encodeURIComponent(JSON.stringify(stateObj));
      const authUrl = `${ATS_API_URL}/integration/google-auth?state=${stateParam}`;

      window.open(
        authUrl,
        "GoogleLogin",
        `width=${width},height=${height},left=${left},top=${top}`
      );
    } catch (err) {
      console.error("Error in regenerate:", err);
      showToast("Failed to regenerate Google login", "error");
    } finally {
      setLoading(false);
    }
  };

  const GoogleIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="16"
      height="16"
      role="img"
      aria-label="Google"
    >
      <title>Google</title>
      <clipPath id="g">
        <path d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z" />
      </clipPath>
      <g clipPath="url(#g)">
        <path fill="#FBBC05" d="M0 37V11l17 13z" />
        <path fill="#EA4335" d="M0 11l17 13 7-6.1L48 14V0H0z" />
        <path fill="#34A853" d="M0 37l30-23 7.9 1L48 0v48H0z" />
        <path fill="#4285F4" d="M48 48L17 24l-4-3 35-10z" />
      </g>
    </svg>
  );
  const fetchRaSettings = () => {
    const action = {
      coll: "Setting",
      lim: 10,
      pg: 1,
      ret: "raSetting uiid bdmSettings",
    };

    dispatch(getRaSettingsStart(action));
  };
  const fetchLocalRestrictions = () => {
    const action = {
      coll: "LocationRestriction",
      lim: limit,
      pg: page,
      ret: "uiid stateName stateCode addedOn",
    };
    dispatch(getLocalRestrictionStart(action));
  };
  const fetchRALocationsData = () => {
    const params = {
      coll: "State",
      lim: limit,
      pg: page,
      fil: {
        addedBy: { type: "NONE", value: user?.data?.uiid }
      },
      
      ret: "name stateCode addedOn uiid",
      
    };
    dispatch(getRALocationsStart({ ...params, fil: JSON.stringify(params.fil) }));

    dispatch(
      totalCountStart({
        collection: "cities",
        coll: "City",
        tname: "bdmlocations",
        filters: { addedBy: { type: "NONE", value: user?.data?.uiid } },
        app: "master",
      })
    );
  };

  const fetchBDMLocationsData = () => {
    const params = {
      coll: "City",
      lim: limit,
      pg: page,
      fil: {
        addedBy: { type: "NONE", value: user?.data?.uiid }
      },
    };
    dispatch(getBDMLocationsStart({ ...params, fil: JSON.stringify(params.fil) }));
  };
  useEffect(() => {
    dispatch(
      totalCountStart({
        collection: "states",
        coll: "State",
        tname: "ralocations",
        filters: { addedBy: { type: "NONE", value: user?.data?.uiid } },
        app: "master",
      })
    );

    fetchRALocationsData()
    fetchBDMLocationsData()
  }, [dispatch, page, limit])

  const handleSaveOrUpdateSettings = () => {
    if (existingUiid) {
      // PATCH
      dispatch(
        updateRaSettingsStart({
          uiid: existingUiid,
          payload: {
            payload: [
              {
                type: "SET",
                value: {
                  "raSetting.addCompanyWithLoc": addCompany === "1",
                  "raSetting.waitingPeriod": Number(lockInPeriod) || 0,
                  "raSetting.prospectWaitingPeriod":
                    Number(lockinProspectPeriod) || 0,
                },
              },
            ],
          },
        })
      );
    } else {
      // POST
      dispatch(
        saveRaSettingsStart({
          coll: "Setting",
          payload: {
            raSetting: {
              addedBy: user.data.uiid,
              addCompanyWithLoc: addCompany === "1",
              waitingPeriod: Number(lockInPeriod) || 0,
              prospectWaitingPeriod: Number(lockinProspectPeriod) || 0,
            },
          },
          onSuccess: (savedDoc) => {
            setExistingUiid(savedDoc.uiid);
          },
        })
      );
    }
  };
  const handleSaveOrUpdateRecruitmentSettings = () => {
    if (!selectedAutoAssign || enteredCredits?.trim()?.length <= 0) {
      showToast("Please fill all the fields", "error", 2000);
      return;
    }
    if (uiid) {
      dispatch(
        updateRaSettingsStart({
          uiid: existingUiid,
          payload: {
            payload: [
              {
                type: "SET",
                value: {
                  "recruitmentSettings.monsterCreditAssign.type": Number(selectedAutoAssign),
                  "recruitmentSettings.monsterCreditAssign.credits": Number(enteredCredits),
                },
              },
            ],
          },
          onSuccess: () => {
            dispatch(getRecruitmentSettingsStart({ coll: "Setting" }));
          },
        })
      );
    } else {
      dispatch(
        saveRaSettingsStart({
          coll: "Setting",
          payload: {
            recruitmentSettings: {
              monsterCreditAssign: {
                type: Number(selectedAutoAssign),
                credits: Number(enteredCredits)
              }
            },
          }
        })
      );
    }
  };

  const handleSaveOrUpdateBDMSetting = () => {
    if (!bdmJobCloseNumber) {
      showToast("Please enter number of days", "error");
      return;
    }
    if (existingUiid) {
      dispatch(
        updateRaSettingsStart({
          uiid: existingUiid,
          payload: {
            payload: [
              {
                type: "SET",
                value: {
                  "bdmSettings.jobInactivityLimitDays":
                    Number(bdmJobCloseNumber),
                },
              },
            ],
          },
        })
      );
      return;
    }

    dispatch(
      saveRaSettingsStart({
        coll: "Setting",
        payload: {
          bdmSettings: {
            jobInactivityLimitDays: Number(bdmJobCloseNumber),
            addedBy: user?.data?.uiid,
          },
        },
        onSuccess: () => {
          // showToast("BDM setting added successfully", "success");
        },
      })
    );
  };

  const handleDeteteRestrictions = async (uiid) => {
    try {
      const res = await deleteLocalRestriction({
        coll: "LocationRestriction",
        uiid,
      });
      if (res?.data) {
        showToast("Restriction deleted successfully", "success", 2000);
        fetchLocalRestrictions()
      } else {
        showToast("Failed to delete restriction", "error");
      }
    } catch (error) {
      console.error("Failed to delete restrictions:", error);
    }
  };

  const handleDeteteRALocation = async (uiid) => {
    try {
      const res = await deleteRALocation({
        coll: "State",
        uiid: uiid
      });
      if (res?.data) {
        showToast("Location deleted successfully", "success", 2000);
        fetchRALocationsData();
      } else {
        showToast("Failed to delete Location", "error");
      }
    } catch (error) {
      console.error("Failed to delete LOcation:", error);
    }
  };
  const handleDeteteBDMLocation = async (uiid) => {
    try {
      const res = await deleteBDMLocation({
        coll: "City",
        uiid: uiid
      });
      if (res?.data) {
        showToast("Location deleted successfully", "success", 2000);
        fetchBDMLocationsData();
      } else {
        showToast("Failed to delete Location", "error");
      }
    } catch (error) {
      console.error("Failed to delete LOcation:", error);
    }
  };

  // const rows = [
  //   {
  //     slno: 1,
  //     AddedOn: "2025-11-10",
  //     stateName: "Karnataka",
  //     stateCode: "KA",
  //   },
  //   {
  //     slno: 2,
  //     AddedOn: "2025-11-08",
  //     stateName: "Maharashtra",
  //     stateCode: "MH",
  //   },
  //   {
  //     slno: 3,
  //     AddedOn: "2025-11-07",
  //     stateName: "Karnataka",
  //     stateCode: "KA",
  //   },
  // ];
  const rows = (restrictions ?? []).map((restriction, idx) => ({
    slno: idx,
    uiid: restriction?.uiid || null,
    AddedOn: restriction?.addedOn
      ? dateFormator(restriction.addedOn, "year-month-date")
      : "-",
    stateName: restriction?.stateName || "-",
    stateCode: restriction?.stateCode || "-",
  }));
  const columns = [
    {
      key: "AddedOn",
      label: "Added On",
      minWidth: 250,
      render: (row) => (
        <div className="text-info cursor-pointer">{row?.AddedOn}</div>
      ),
    },
    {
      key: "stateName",
      label: "State Name",
      width: 250,
      render: (row) => (
        <div className="text-info cursor-pointer">{row?.stateName}</div>
      ),
    },
    {
      key: "stateCode",
      label: "State Code",
      width: 250,
      render: (row) => (
        <div className="text-info cursor-pointer">{row.stateCode}</div>
      ),
    },
    {
      key: "",
      label: "Actions",
      width: 150,
      render: (row) => (
        <div className="flex items-center justify-between gap-2">
          <SmartTooltip description={"Delete"} noicon>
            <Button
              type="icon"
              variant="text"
              icon="delete"
              size="xs"
              color="black"
              onClick={() => handleDeteteRestrictions(row?.uiid)}
            />
          </SmartTooltip>
        </div>
      ),
    },
  ];

  const locationRows = (raAddedLocations?.data ?? []).map((location, idx) => ({
    slno: idx,
    uiid: location?.uiid || null,
    AddedOn: location?.addedOn ?? "-"
      ? dateFormator(location.addedOn, "year-month-date")
      : "-",
    stateName: location?.name ?? "-",
    stateCode: location?.stateCode ?? "-",
  }));

  const locationBDMRows = (bdmAddedLocations?.data ?? []).map((location, idx) => ({
    slno: idx,
    uiid: location?.uiid || null,
    AddedOn: location?.addedOn ?? "-"
      ? dateFormator(location.addedOn, "year-month-date")
      : "-",
    country: location?.country && location?.country == "6807640e7ecb9f7d31314b7e" ? "US" : "CA",
    stateName: location?.stateName ?? "-",
    cityName: location?.name ?? "-",
     zipCode: Array.isArray(location?.zipCode) && location.zipCode.length > 0 
    ? location.zipCode[0] 
    : "-"
  }));

  const locationBDMAddColumns = [
    {
      key: "AddedOn",
      label: "Added On",
      minWidth: 250,
      render: (row) => (
        <div className="text-info cursor-pointer">{row?.AddedOn}</div>
      ),
    },
    {
      key: "country",
      label: "country Name",
      width: 250,
      render: (row) => (
        <div className="text-info cursor-pointer">{row?.country}</div>
      ),
    },
    {
      key: "stateName",
      label: "State Name",
      width: 250,
      render: (row) => (
        <div className="text-info cursor-pointer">{row?.stateName}</div>
      ),
    },
    {
      key: "cityName",
      label: "city Name",
      width: 250,
      render: (row) => (
        <div className="text-info cursor-pointer">{row.cityName}</div>
      ),
    },
    {
      key: "zipCode",
      label: "zipCode",
      width: 250,
      render: (row) => (
        <div className="text-info cursor-pointer">{row.zipCode}</div>
      ),
    },
    {
      key: "",
      label: "Actions",
      width: 150,
      render: (row) => (
        <div className="flex items-center justify-between gap-2">
          <SmartTooltip description={"Delete"} noicon>
            <Button
              type="icon"
              variant="text"
              icon="delete"
              size="xs"
              color="black"
              onClick={() => handleDeteteBDMLocation(row?.uiid)}
            />
          </SmartTooltip>
        </div>
      ),
    },
  ];

  const locationAddColumns = [
    {
      key: "AddedOn",
      label: "Added On",
      minWidth: 250,
      render: (row) => (
        <div className="text-info cursor-pointer">{row?.AddedOn}</div>
      ),
    },
    {
      key: "stateName",
      label: "State Name",
      width: 250,
      render: (row) => (
        <div className="text-info cursor-pointer">{row?.stateName}</div>
      ),
    },
    {
      key: "stateCode",
      label: "State Code",
      width: 250,
      render: (row) => (
        <div className="text-info cursor-pointer">{row.stateCode}</div>
      ),
    },
    {
      key: "",
      label: "Actions",
      width: 150,
      render: (row) => (
        <div className="flex items-center justify-between gap-2">
          <SmartTooltip description={"Delete"} noicon>
            <Button
              type="icon"
              variant="text"
              icon="delete"
              size="xs"
              color="black"
              onClick={() => handleDeteteRALocation(row?.uiid)}
            />
          </SmartTooltip>
        </div>
      ),
    },
  ];

  const mappedRows = mapTableRows(rows, columns);

  const data = [
    {
      title: "Company Settings",
      id: "settings_configurations_generalsettings_rasettings_companysetting",
      content: (
        <div className="px-1 my-2 gap-3 flex flex-col justify-between overflow-auto ">
          <div>
            <p className="font-medium flex items-center gap-1">
              Add Company to Lead
              <SmartTooltip description="Add Company Settings" noicon>
                <Button
                  type="icon"
                  variant="text"
                  icon={"info"}
                  color="black"
                />
              </SmartTooltip>
            </p>
            <FormFieldSet
              // title="Add Company to Lead"
              noTitle
              type="radio"
              options={[
                { label: "Add Company with Location", value: "1" },
                { label: "Add Company without Location", value: "2" },
              ]}
              // value={addCompany}
              // onChange={handleSelectionChange}
              // value={addCompany} // <- controlled by state
              // onChange={(value) => setAddCompany(value)} // <-
              value={addCompany}
              // onChange={(value) => setAddCompany(value)}
              // onChange={(value) => setAddCompany(value)}
              onChange={handleSelectionChange}
            />

            <div className="flex gap-8">
              <div className="grid grid-cols-1 my-4">
                <div className="col-span-2">
                  <p className="font-medium flex items-center gap-1">
                    Waiting period to Re-Add Company
                    <SmartTooltip
                      description="The system will block adding the same company until the period has passed"
                      noicon
                    >
                      <Button
                        type="icon"
                        variant="text"
                        icon={"info"}
                        color="black"
                      />
                    </SmartTooltip>
                  </p>
                  <FormFieldSet
                    // title="Waiting Period"
                    noTitle
                    placeholder="Enter number of days"
                    // value={lockInPeriod}
                    // onChange={(value) => {
                    //   setLockInPeriod(value);
                    // }}
                    // value={lockInPeriod} // <- controlled by state
                    // onChange={(value) => setLockInPeriod(value)} //
                    value={lockInPeriod}
                    onChange={(value) => setLockInPeriod(value)}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 my-4">
                <div className="col-span-2">
                  <p className="font-medium flex items-center gap-1">
                    Waiting period to Re-Add Prospect
                    <SmartTooltip
                      description="The system will block adding the same prospect until the period has passed"
                      noicon
                    >
                      <Button
                        type="icon"
                        variant="text"
                        icon={"info"}
                        color="black"
                      />
                    </SmartTooltip>
                  </p>
                  <FormFieldSet
                    // title="Waiting Period"
                    noTitle
                    placeholder="Enter number of days"
                    // value={lockInPeriod}
                    // onChange={(value) => {
                    //   setLockInPeriod(value);
                    // }}
                    // value={lockInPeriod} // <- controlled by state
                    // onChange={(value) => setLockInPeriod(value)} //
                    value={lockinProspectPeriod}
                    onChange={(value) => setLockinProspectPeriod(value)}
                  />
                </div>
              </div>
            </div>

            {/* <div className="flex gap-2">
              {!isGoogleConnected && !isDisconnected ? (
                <>
                  <Button
                    title={"Connect Google Account"}
                    variant="outlined"
                    size="sm"
                    onClick={handleGoogleClick}
                    icon={GoogleIcon}
                    color={
                      !showEnableButton && !showEnabledButton ? "info" : "black"
                    }
                  />

                  {showEnableButton && (
                    <Button
                      title={"Enable Google Search Api"}
                      // https://console.cloud.google.com/welcome/new
                      variant="text"
                      size="sm"
                      color="info"
                      // onClick={handleEnableApi}
                      onClick={() => {
                        if (tosLink) {
                          window.open(tosLink, "_blank", "noopener,noreferrer");
                          setShowEnableButton(false);
                        }
                        // else {
                        //   handleEnableApi();
                        // }
                      }}
                    />
                  )}

                  {showEnabledButton && (
                    <Button
                      title={"API Enabled Google Search Api"}
                      variant="outlined"
                      size="sm"
                      color="info"
                      onClick={handleEnabledButtonClick}
                    />
                  )}
                </>
              ) : isGoogleConnected ? (
                <div className="flex items-center gap-2 border border-success rounded px-3 py-1">
                  {GoogleIcon}
                  <p className="text-success text-xs">
                    {/* Connected (asthavaish17@tektree.in) */}
            {/* Connected {activeGmail}
                  </p>
                  <DropdownMenu
                    MenuSection={
                      <div className="flex flex-col">
                        <Button
                          title={"Regenerate"}
                          variant="text"
                          color="black"
                          size="xs-sm"
                          className="!justify-start py-1"
                          onClick={handleRegenerate}
                        />
                        <Button
                          title={"Disconnect"}
                          variant="text"
                          color="black"
                          size="xs-sm"
                          className="!justify-start py-1"
                          onClick={handleDisconnect}
                        />
                      </div>
                    }
                  >
                    <Button
                      icon={"more_vert"}
                      variant="text"
                      type="icon"
                      size="xs"
                      color="black"
                    />
                  </DropdownMenu>
                </div>
              ) : (
                <div className="flex items-center gap-2 border border-danger rounded px-3 py-1">
                  {GoogleIcon}
                  <p className="text-danger text-xs">Disconnected</p>
                  <DropdownMenu
                    MenuSection={
                      <Button
                        title={"Connect"}
                        variant="text"
                        color="black"
                        size="xs-sm"
                        className="!justify-start py-1"
                        onClick={handleRegenerate}
                      />
                    }
                  >
                    <Button
                      icon={"more_vert"}
                      variant="text"
                      type="icon"
                      size="xs"
                      color="black"
                    />
                  </DropdownMenu>
                </div>
              )} */}
            {/* </div> */}
            {/* <div className="flex gap-2">
              {activeGmail ? (
                <div className="flex items-center gap-2 border border-success rounded px-3 py-1">
                  {GoogleIcon}
                  <p className="text-success text-xs">
                    Connected ({activeGmail})
                  </p>
                  <DropdownMenu
                    MenuSection={
                      <div className="flex flex-col">
                        <Button
                          title={"Regenerate"}
                          variant="text"
                          color="black"
                          size="xs-sm"
                          className="!justify-start py-1"
                          onClick={handleRegenerate}
                        />
                        <Button
                          title={"Disconnect"}
                          variant="text"
                          color="black"
                          size="xs-sm"
                          className="!justify-start py-1"
                          onClick={handleDisconnect}
                        />
                      </div>
                    }
                  >
                    <Button
                      icon={"more_vert"}
                      variant="text"
                      type="icon"
                      size="xs"
                      color="black"
                    />
                  </DropdownMenu>
                </div>
              ) : (
                <>
                  <Button
                    title={"Connect Google Account"}
                    variant="outlined"
                    size="sm"
                    onClick={handleGoogleClick}
                    icon={GoogleIcon}
                    color={
                      !showEnableButton && !showEnabledButton ? "info" : "black"
                    }
                    className="font-semibold"
                  />

                  {showEnabledButton && (
                    <Button
                      title={"API Enabled Google Search Api"}
                      variant="outlined"
                      size="sm"
                      color="info"
                      onClick={handleEnabledButtonClick}
                    />
                  )}
                </>
              )}
              {showEnableButton && (
                <Button
                  title={"Enable Google Search Api"}
                  variant="text"
                  size="sm"
                  color="info"
                  onClick={() => {
                    if (tosLink) {
                      window.open(tosLink, "_blank", "noopener,noreferrer");
                      setShowEnableButton(false);
                    }
                  }}
                />
              )}
            </div> */}
          </div>

          {/* <div className="flex gap-2 my-3 justify-end mt-10 mb-5">
            <Button variant="outlined" title={"Cancel"} color="black" />
            <Button title={"Save"} onClick={handleSaveOrUpdateSettings} />
          </div> */}
        </div>
      ),
    },
    {
      title: "Google Search Account Settings",
      id: "settings_configurations_generalsettings_rasettings_googleSetting",
      content: (
        <div className="px-1 my-2 gap-3 flex flex-col justify-between overflow-auto ">
          <div className="flex gap-2">
            {activeGmail ? (
              <div className="flex items-center gap-2 border border-success rounded px-3 py-1">
                {GoogleIcon}
                <p className="text-success text-xs">
                  Connected ({activeGmail})
                </p>
                <DropdownMenu
                  MenuSection={
                    <div className="flex flex-col">
                      <Button
                        title={"Regenerate"}
                        variant="text"
                        color="black"
                        size="xs-sm"
                        className="!justify-start py-1"
                        onClick={handleRegenerate}
                      />
                      <Button
                        title={"Disconnect"}
                        variant="text"
                        color="black"
                        size="xs-sm"
                        className="!justify-start py-1"
                        onClick={handleDisconnect}
                      />
                      <Button
                        title={"Change Search Key"}
                        variant="text"
                        color="black"
                        size="xs-sm"
                        className="!justify-start py-1"
                        onClick={() => setShowStepTwo(true)}
                      />
                    </div>
                  }
                >
                  <Button
                    icon={"more_vert"}
                    variant="text"
                    type="icon"
                    size="xs"
                    color="black"
                  />
                </DropdownMenu>
              </div>
            ) : (
              <>
                <Button
                  title={
                    isDisconnected ? "Disconnected" : "Connect Google Account"
                  }
                  variant="outlined"
                  size="sm"
                  onClick={handleGoogleClick}
                  icon={GoogleIcon}
                  color={
                    isDisconnected
                      ? "danger"
                      : !showEnableButton && !showEnabledButton
                        ? "info"
                        : "black"
                  }
                  className="font-semibold"
                />

                {showEnabledButton && (
                  <Button
                    title={"API Enabled Google Search Api"}
                    variant="outlined"
                    size="sm"
                    color="info"
                    onClick={handleEnabledButtonClick}
                  />
                )}
              </>
            )}
            {showEnableButton && (
              <Button
                title={"Enable Google Search Api"}
                variant="text"
                size="sm"
                color="info"
                onClick={() => {
                  if (tosLink) {
                    window.open(tosLink, "_blank", "noopener,noreferrer");
                    setShowEnableButton(false);
                  }
                }}
              />
            )}
          </div>
        </div>
      ),
    },
    {
      title: "Location restriction Settings",
      id: "settings_configurations_generalsettings_rasettings_locationrestrictionsettings",
      content: (
        <div className="h-fit overflow-auto shadow-tableset px-1">
          <TableAdv
            columns={columns}
            showSlNo
            rows={rows}
            serverPagination={true}
            totalCount={totalCount}
            page={page}
            limit={limit}
            onPageChange={setPage}
            onLimitChange={handleLimitChange}
            toolbarRight={{
              search: true,
              add: [
                {
                  component: (
                    <Button
                      title={"Add"}
                      size="sm"
                      onClick={() => setShowAddButtonModal(true)}
                    />
                  ),
                },
              ],
            }}
          />
        </div>
      ),
    },
    {
      title: "Location Add Settings",
      id: "settings_configurations_generalsettings_rasettings_locationaddsettings",
      content: (
        <div className="flex-1 overflow-auto shadow-tableset px-1">
          <TableAdv
            columns={locationAddColumns}
            showSlNo
            rows={locationRows}
            serverPagination={true}
            totalCount={totalCount}
            page={page}
            limit={limit}
            onPageChange={setPage}
            onLimitChange={handleLimitChange}
            toolbarRight={{
              search: true,
              add: [
                {
                  component: (
                    <Button
                      title={"Add"}
                      size="sm"
                      onClick={() => setshowLocationAddButtonModal(true)}
                    />
                  ),
                },
              ],
            }}
          />
        </div>
      ),
    },
  ];
  const BdmData = [
    {
      title: "Job Settings",
      id: "settings_configurations_generalsettings_bdmsettings_jobsetting",
      content: (
        <div className="grid grid-cols-6 my-4 px-1">
          <div className="col-span-2">
            <p className="font-medium flex items-center gap-1">
              Change Job Status Close
              <SmartTooltip description="Add Company Settings" noicon>
                <Button
                  type="icon"
                  variant="text"
                  icon={"info"}
                  color="black"
                />
              </SmartTooltip>
            </p>
            <FormFieldSet
              noTitle
              placeholder="Enter number of days"
              value={bdmJobCloseNumber}
              onChange={(value) => setBdmJobCloseNumber(value)}
            />
          </div>
        </div>
      ),
    },
    {
      title: "JobBoard Location Add Settings",
      id: "settings_configurations_generalsettings_bdmsettings_jobBoardLocationAddSettings",
      content: (
        <div className="flex-1 overflow-hidden shadow-tableset px-1">
          <TableAdv
            columns={locationBDMAddColumns}
            showSlNo
            rows={locationBDMRows}
            serverPagination={true}
            totalCount={totalCount}
            page={page}
            limit={limit}
            onPageChange={setPage}
            onLimitChange={handleLimitChange}
            toolbarRight={{
              search: true,
              add: [
                {
                  component: (
                    <Button
                      title={"Add"}
                      size="sm"
                      onClick={() => setshowBDMLocationAddButtonModal(true)}
                    />
                  ),
                },
              ],
            }}
          />
        </div>
      ),
    },
  ];
  const RecruitmentData = [
    {
      title: "Jobboard Settings",
      id: "settings_configurations_generalsettings_recruitmentsettings_jobboardsetting",
      content: (
        <div className="flex flex-col gap-2 my-2">
          <div className="grid grid-cols-6">
            <div className="col-span-2">
              <p className="font-medium">Jobboard</p>
              <FormFieldSet
                type="select"
                noTitle
                placeholder="Select Jobboard"
                options={[{label: "Monster", value: 1}]}
                value={selectedJobBoard}
                onChange={(value) => setSelectedJobBoard(value)}
              />
            </div>
          </div>          
          <div className="grid grid-cols-3">
            <div>
              <p className="font-medium flex items-center gap-1">
                Auto Assign Credits
                <SmartTooltip description="Automatically assign credits when the user’s available credits are fully consumed." noicon>
                  <Button
                    type="icon"
                    variant="text"
                    icon={"info"}
                    color="black"
                  />
                </SmartTooltip>
              </p>
              <FormFieldSet
                noTitle
                type="radio"
                options={[
                  { label: "All Users", value: "1" },
                  { label: "Selected Users", value: "2" },
                ]}
                value={selectedAutoAssign}
                onChange={(e) => setSelectedAutoAssign(e.target.value)}
              />
            </div>
            {selectedAutoAssign && (
              <div>
                <p className="font-medium">Number of Credits</p>
                <FormFieldSet
                  noTitle
                  placeholder="Enter number of credits"
                  value={enteredCredits}
                  onChange={(value) => {
                    if (/^\d*$/.test(value)) {
                      setEnteredCredits(value);
                    }
                  }}
                />
              </div>    
            )}                   
          </div>
          
        </div>
      ),
    }
  ];
  const filteredRaSettingsTabs = useModuleAccess({
    allTabs: data,
    parentId: "settings_configurations_generalsettings_rasettings",
    accessKey:
      portal === "bs" ? "benchsales" : portal === "wf" ? "workforce" : "ats",
  });
  const filteredBdmSettingsTabs = useModuleAccess({
    allTabs: BdmData,
    parentId: "settings_configurations_generalsettings_bdmsettings",
    accessKey:
      portal === "bs" ? "benchsales" : portal === "wf" ? "workforce" : "ats",
  });
  const filteredRecruitmentSettingsTabs = useModuleAccess({
    allTabs: RecruitmentData,
    parentId: "settings_configurations_generalsettings_recruitmentsettings",
    accessKey:
      portal === "bs" ? "benchsales" : portal === "wf" ? "workforce" : "ats",
  });

  const tabList = [
    {
      title: "RA Setting",
      page: (
        <div className="flex-1 p-2 flex flex-col overflow-x-hidden">
          <div className="mb-3">
            <AccordianNew
              data={filteredRaSettingsTabs}
              openDefault={openAccordion}
              iconPosition="right"
              variant="outlined"
              color={"white"}
            />
          </div>

          <div className="mt-auto flex gap-2 justify-end py-5">
            <Button variant="outlined" title={"Cancel"} color="black" />
            <Button title={"Save"} onClick={handleSaveOrUpdateSettings} />
          </div>
        </div>
      ),
      id: "settings_configurations_generalsettings_rasettings",
    },
    {
      title: "BDM Setting",
      page: (
        <div className="flex-1 p-2 flex flex-col overflow-x-hidden">
          <div>
            <AccordianNew
              data={filteredBdmSettingsTabs}
              openDefault={openAccordion}
              iconPosition="right"
              variant="outlined"
              color={"white"}
            />
          </div>

          <div className="mt-auto flex gap-2 justify-end mb-5">
            <Button variant="outlined" title={"Cancel"} color="black" />
            <Button title={"Save"} onClick={handleSaveOrUpdateBDMSetting} />
          </div>
        </div>
      ),
      id: "settings_configurations_generalsettings_bdmsettings",
    },
    {
      title: "Recruitement",
      page: (
        <div className="flex-1 p-2 flex flex-col overflow-x-hidden">
          <div>
            <AccordianNew
              data={filteredRecruitmentSettingsTabs}
              openDefault={openAccordion}
              iconPosition="right"
              variant="outlined"
              color={"white"}
            />
          </div>

          <div className="mt-auto flex gap-2 justify-end mb-5">
            <Button variant="outlined" title={"Cancel"} color="black" />
            <Button title={"Save"} onClick={handleSaveOrUpdateRecruitmentSettings} />
          </div>
        </div>
      ),
      id: "settings_configurations_generalsettings_recruitement",
    },
    {
      title: "Bench Sale Setting",
      id: "settings_configurations_generalsettings_benchsalesetting",
      page: (
        <div className="flex-1 p-2">
          <div>Bench Sale Setting</div>
        </div>
      ),
    },
    {
      title: "AI Recruiter Call",
      id: "settings_configurations_generalsettings_benchsalesetting",
      page: (
        <div className="flex-1 p-2">
          <AiRecruiterCall/>
        </div>
      ),
    },
  ];
  const filteredTabs = useModuleAccess({
    allTabs: tabList,
    parentId: "settings_configurations_generalsettings",
    accessKey:
      portal === "bs" ? "benchsales" : portal === "wf" ? "workforce" : "ats",
  });

  useEffect(() => {
    if (raSettings?.length > 0) {
      setExistingUiid(raSettings[0].uiid);
      setAddCompany(raSettings[0].raSetting.addCompanyWithLoc ? "1" : "2");
      setLockInPeriod(String(raSettings[0].raSetting.waitingPeriod ?? ""));
      setLockinProspectPeriod(
        String(raSettings[0].raSetting.prospectWaitingPeriod ?? "")
      );
      if (raSettings[0]?.bdmSettings) {
        setBdmJobCloseNumber(
          raSettings[0]?.bdmSettings?.jobInactivityLimitDays ?? ""
        );
      }
    }
  }, [raSettings]);

  useEffect(() => {
    fetchRaSettings();
    dispatch(getRecruitmentSettingsStart({coll: "Setting"}));
  }, []);

  useEffect(() => {
    const initIntegrationUiid = async () => {
      try {
        const checkRes = await checkAdminAdded({
          coll: "Integration",
          fil: {
            category: { type: "NONE", value: 7 },
            type: { type: "NONE", value: 1 },
          },
        });

        if (checkRes?.data?.data?.uiid) {
          setIntegrationAccessUiid(checkRes.data.data.uiid);
        }
      } catch (err) {
        console.error("Failed to init integrationUiid", err);
      }
    };

    initIntegrationUiid();
  }, []);

  useEffect(() => {
    const initIntegrationUiid = async () => {
      try {
        const checkRes = await checkAdminAdded({
          coll: "Integration",
          fil: {
            category: { type: "NONE", value: 7 },
            type: { type: "NONE", value: 1 },
          },
        });

        if (checkRes?.data?.data?.uiid) {
          setIntegrationAccessUiid(checkRes.data.data.uiid);
        }
      } catch (err) {
        console.error("Failed to init integrationUiid", err);
      }
    };

    initIntegrationUiid();
  }, []);

  useEffect(() => {
    const initIntegrationAccessUiid = async () => {
      try {
        let accessRes = await getIntegrationAccess({
          ret: "status uiid accessConfig",
          coll: "IntegrationAccess",
          fil: {
            integrationId: { type: "NONE", value: integrationAccessUiid },
            addedBy: { type: "NONE", value: user.data.uiid },
          },
        });
        if (accessRes?.data) {
          const { status, uiid, accessConfig } = accessRes.data.data;
          if (status === 2) {
            const statusUpdate = await updateIntegrationAccessStatus({
              uiid,
              payload: [
                {
                  type: "SET",
                  value: { status: 1 },
                },
              ],
            });
          }
          dispatch(
            setActiveGmailStart({
              gmail: accessConfig.activeGmail,
            })
          );
          setIsGoogleConnected(true);
          // setIsGoogleConnected(true);
          // setShowEnableButton(false);
          // setTosLink(null);
        }
      } catch (err) {
        console.error("Failed to init integrationUiid", err);
      }
    };

    initIntegrationAccessUiid();
  }, [integrationAccessUiid]);

  useEffect(() => {
    dispatch(
      totalCountStart({
        collection: "locationrestrictions",
        coll: "LocationRestriction",
        tname: "localRestrictionCount",
        app: "ats",
      })
    );
    fetchLocalRestrictions();
  }, [dispatch, limit, page]);

  useEffect(() => {
    if (recruitmentSettings?.monsterCreditAssign?.type) {
      setSelectedAutoAssign(String(recruitmentSettings?.monsterCreditAssign?.type));
    }
    if (recruitmentSettings?.monsterCreditAssign?.credits) {
      setEnteredCredits(String(recruitmentSettings?.monsterCreditAssign?.credits));
    }
  }, [recruitmentSettings])

  if (loading) {
    return (
      <div className="absolute inset-0 flex items-center justify-center bg-white/40 backdrop-blur-sm z-50 rounded-lg">
        <LogoLoader />
      </div>
    );
  }
  return (
    <div className="flex flex-1 pt-2 overflow-hidden">
      {isLoading ? (
        <div className="flex justify-center items-center gap-3 h-screen">
          <LogoLoader />
          <p className="text-gray-500">Step:1 In Progress, please wait.</p>
        </div>
      ) : showStepTwo ? (
        <div className="flex flex-col items-center justify-center h-screen">
          <div className="flex flex-col items-start">
            <p className="mb-2">Step:2</p>
            <div className="mb-4 flex items-center gap-1">
              <SmartTooltip
                key="black"
                description={
                  <div className="flex flex-col gap-2">
                    <p>Helpful Microscopy:</p>
                    <p>
                      “How to find CX: Go to Control Panel → Create → Name your
                      engine → Under 'Setup' copy the 'Search engine ID' (starts
                      with '012345...')
                    </p>
                    <p>
                      Add a small help link: Need help? → opens tooltip or short
                      video/gif.
                    </p>
                    <p>Paste CX modal / input</p>
                    <p>Input label: Search engine ID (cx)</p>
                    <p>Placeholder: e.g. 012345678901234567890:abcdefg</p>
                    <p>Buttons: Save / Cancel</p>
                    <p>
                      Validation: basic format check (length/characters). On
                      save, call backend to store it and verify with a test
                      search.
                    </p>
                    <p>Final success screen (once CX saved + verified)</p>
                  </div>
                }
                variant={"text"}
                size="xs"
              >
                <span>Create Search Engine</span>
              </SmartTooltip>
            </div>
            <div className="flex items-center gap-2">
              <Button
                title="Open Programmable Search Engine"
                color="info"
                variant="outlined"
                onClick={() =>
                  window.open(
                    "https://programmablesearchengine.google.com/controlpanel/create",
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              />
              <Button
                title="I've created it, paste CX"
                color={"black"}
                onClick={() => setShowCxModal(true)}
              />
            </div>
          </div>
        </div>
      ) : (
        // <div className="grid grid-cols-12 gap-4 px-3 py-5">
        //   <div className="col-span-2 inner-section min-h-[60vh] flex-col rounded-lg border-r border-[#e7e7e7]">
        //     {options.map((option, index) => (
        //       <div
        //         key={index}
        //         className={`py-3 px-2 border-b border-[#e7e7e7] cursor-pointer text-sm ${
        //           activeIndex === 0 && `rounded-t-lg`
        //         } ${activeIndex === index ? "bg-primary-100" : "bg-white"}`}
        //         onClick={() => setActiveIndex(index)}
        //       >
        //         {option}
        //       </div>
        //     ))}
        //   </div>
        //   <div className="col-span-10 border max-h-[60vh] border-[#e7e7e7] rounded-lg p-2 overflow-y-auto">
        //     {activeIndex === 0 ? (
        //       <AccordianNew
        //         data={data}
        //         openDefault={openAccordion}
        //         iconPosition="right"
        //         variant="outlined"
        //         color={"white"}
        //       />
        //     ) : activeIndex === 1 ? (
        //       <div>BDM Setting</div>
        //     ) : activeIndex === 2 ? (
        //       <div>Recruitment</div>
        //     ) : (
        //       <div>Bench Sale Setting</div>
        //     )}
        //   </div>
        // </div>
        <VerticalTabs
          tabs={filteredTabs}
          activeColor="primary"
          activeVariant="contained"
        />
      )}

      <div className="h-100">
        <Modal
          title={"I've created it, paste CX"}
          isOpen={showCxModal}
          onClose={() => {
            setShowCxModal(false);
          }}
          width="max-w-3xl"
          titleColor={"primary"}
        >
          <div className="flex flex-col justify-center items-center">
            <div className="w-fit">
              <FormFieldSet
                title="Paste ID"
                value={cxKey}
                onChange={(value) => setCxKey(value)}
                placeholder="Enter CX ID"
              />
              <div className="flex justify-end gap-3 my-4">
                <Button
                  title={"Cancel"}
                  variant="outlined"
                  onClick={() => setShowCxModal(false)}
                />
                <Button
                  title={"Save"}
                  // onClick={() => {
                  //   setIsGoogleConnected(true);
                  //   setShowCxModal(false);
                  //   setShowStepTwo(false);
                  //   setIsDisconnected(false);
                  //   setOpenAccordion(0);
                  // }}
                  onClick={handleSaveCxKey}
                />
              </div>
            </div>
          </div>
        </Modal>
        <GeneralSettingsAddButtonModal
          showAddButtonModal={showAddButtonModal}
          setShowAddButtonModal={setShowAddButtonModal}
          onSuccess={fetchLocalRestrictions}
        />
        <GeneralSettingsAddRALocationButtonModal
          showAddButtonModal={showLocationAddButtonModal}
          setShowAddButtonModal={setshowLocationAddButtonModal}
          onSuccess={fetchRALocationsData}
        />
        <GeneralSettingsBDMAddButtonModal
          showAddButtonModal={showBDMLocationAddButtonModal}
          setShowAddButtonModal={setshowBDMLocationAddButtonModal}
          onSuccess={fetchBDMLocationsData}
        />
      </div>
      <Backdrop isOpen={settingLoading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default GeneralSettings;
